var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v("Geplande overzet van database")]),
      _vm.results.length == 0
        ? _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c("w-col", { attrs: { xs: "12" } }, [
                    _vm._v(" Geen overzets gepland "),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "w-list",
            [
              _c(
                "w-list-item",
                { key: "title" },
                [
                  _c("w-list-item-text", [_vm._v("Account ID")]),
                  _c("w-list-item-text", [_vm._v("Naar database")]),
                  _c("w-list-item-action"),
                  _c("w-list-item-action"),
                ],
                1
              ),
              _vm._l(_vm.results, function (item) {
                return _c(
                  "w-list-item",
                  { key: item.companyId },
                  [
                    _c("w-list-item-text", [_vm._v(_vm._s(item.companyId))]),
                    _c("w-list-item-text", [_vm._v(_vm._s(item.targetDbId))]),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Account bekijken",
                                expression: "'Account bekijken'",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.openCompany(item.companyId)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "eye" } })],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Taak annuleren",
                                expression: "'Taak annuleren'",
                              },
                            ],
                            staticClass: "danger",
                            on: {
                              click: function ($event) {
                                return _vm.removeQueuedMove(item.companyId)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "trash" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }